import type {
  BatMetadataConfigEntry,
  FieldMetadataMessageDescriptorDef,
} from './common/types';
import { coreFields } from './common/commonFields';
import { locationFields } from './common/locationFields';
import { msg } from '@lingui/core/macro';
import { currencyField, beaCodeField } from './common/expenditureFields';

const corporate315InvestmentsCurrencyQuantity: FieldMetadataMessageDescriptorDef =
  {
    displayName: msg({
      message: 'Revenue',
      context: 'The amount invested over the measurement period',
    }),
    externalDescription: msg({
      message: 'The amount invested over the measurement period',
      context: 'Revenue',
    }),
  };

export const corporate315InvestmentsMetadata = {
  displayName: msg({
    message: 'Corporate investments',
    context: 'Activity data schema name for corporate investments',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    asset_value: {
      displayName: msg({
        message: 'Asset value',
        context: 'The sum of total company equity and debt',
      }),
      externalDescription: msg({
        message: 'The sum of total company equity and debt',
        context: 'Asset value',
      }),
    },
    bea_code: beaCodeField,
    currency: currencyField,
    currency_quantity: corporate315InvestmentsCurrencyQuantity,
    // NOTE: quantity does not exist on the BAT but currency_quantity is
    // renamed to quantity in the BART-EM matching process
    quantity: corporate315InvestmentsCurrencyQuantity,
    outstanding_amount: {
      displayName: msg({
        message: 'Outstanding amount',
        context:
          'The outstanding value of debt owed to the lender, equity held in a private company, or market price times number of shares for listed equity',
      }),
      externalDescription: msg({
        message:
          'The outstanding value of debt owed to the lender, equity held in a private company, or market price times number of shares for listed equity',
        context: 'Outstanding amount',
      }),
    },
    ws_description: {
      displayName: msg({
        message: 'Asset name',
        context: 'The name of the asset being invested in',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
